import { useSearchParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { XCircle, RefreshCw, ArrowLeft } from 'lucide-react';
import { Btn } from '@/presentation/component/ui';

export const PaymentCancelPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const subcategoryId = searchParams.get('subcategory_id');
  const subcategoryName = searchParams.get('subcategory_name');
  const errorMessage = searchParams.get('error');

  const handleRetry = () => {
    if (subcategoryId) {
      navigate(`/subcategory/${subcategoryId}`);
    } else {
      navigate('/formation');
    }
  };

  return (
    <div className="min-h-[60vh] flex items-center justify-center p-4">
      <div className="bg-[var(--color-surface)] rounded-lg shadow-lg p-8 max-w-md w-full text-center">
        <div className="w-16 h-16 bg-[var(--color-bad-bg)] rounded-full flex items-center justify-center mx-auto mb-6">
          <XCircle className="w-8 h-8 text-[var(--color-bad)]" />
        </div>

        <h1 className="text-2xl font-semibold text-[var(--color-ink)] mb-4">
          {t('payment.paymentFailed')}
        </h1>

        <p className="text-[var(--color-ink-soft)] mb-6">
          {errorMessage || t('payment.paymentCancelled')}
        </p>

        {subcategoryName && (
          <div className="bg-[var(--color-surface-2)] rounded-lg p-4 mb-6">
            <p className="text-sm text-[var(--color-ink-soft)]">
              {t('payment.attemptedPurchase')}:{' '}
              <span className="font-medium text-[var(--color-ink)]">{subcategoryName}</span>
            </p>
          </div>
        )}

        <div className="space-y-4">
          <div className="text-left bg-[var(--color-accent-tint)] border border-[var(--color-accent-soft)] rounded-lg p-4">
            <h3 className="font-medium text-[var(--color-accent-ink)] mb-2">
              {t('payment.whatYouCanDo')}
            </h3>
            <ul className="text-sm text-[var(--color-accent-ink)] space-y-1">
              <li>• {t('payment.tryDifferentPaymentMethod')}</li>
              <li>• {t('payment.checkPaymentDetails')}</li>
              <li>• {t('payment.contactSupportIfIssue')}</li>
            </ul>
          </div>

          <div className="flex flex-col gap-3">
            <Btn kind="primary" icon={<RefreshCw className="w-4 h-4" />} onClick={handleRetry}>
              {t('buttons.tryAgain')}
            </Btn>
            <Btn kind="ghost" onClick={() => navigate('/formation')}>
              {t('buttons.backToFormation')}
            </Btn>
            <Btn
              kind="ghost"
              icon={<ArrowLeft className="w-4 h-4" />}
              onClick={() => navigate('/')}
            >
              {t('buttons.backToHome')}
            </Btn>
          </div>
        </div>
      </div>
    </div>
  );
};
